import RadioButton, { LabelText } from '@anm/components/form/RadioButton';
import styled, { css } from 'styled-components';

const checkedCss = css`
  background: #d9f2ff;
`;

export const RadioButtonWrapper = styled(RadioButton)`
  padding: 12px;
  margin-top: 8px;
  border-radius: 10px;
  &:hover {
    background: #f4f6f7;
  }
  ${({ isChecked }) => isChecked && checkedCss}
`;
const TeamMemberRolesInputWrapper = styled.div`
  position: relative;
  ${LabelText} {
    align-items: flex-start;
    &::before {
      background: #fff;
    }
  }
`;

export default TeamMemberRolesInputWrapper;
